import React from 'react'

import './EditCommentCalling.css';
import { DraftEditor } from './_DraftEditor';
import { CustomerCardModel } from '../models/CustomerCardModel';
import { RootState } from '../app-context/store';
import { useDispatch, useSelector } from 'react-redux';
import { setReloadLeadTreatments } from '../app-context/leadsSlice';

interface EditCommentCallingProps {
    onClose: () => void;
    treatment: any;
}


const EditCommentCalling: React.FC<EditCommentCallingProps> = (props: EditCommentCallingProps) => {
    const customerModel = new CustomerCardModel();
    const dispatch = useDispatch();
    const [summaryCalling, setSummaryCalling] = React.useState<string>(props.treatment.emailBody || '');
    const leadIdForTreatment = useSelector((state: RootState) => state.leads.leadIdForTreatment);

    const saveTreatment = async () => {
        console.log('Saving treatment', props.treatment);
        const updataTreatment = {
            ...props.treatment,
            emailBody: summaryCalling,
        };
        try {
            const res = await customerModel.treatmentsUpsertTreatment(updataTreatment);
            console.log('res', res)
            if (res && res.label === "טיפול שוטף נוצר בהצלחה!" || res.label === "טיפול שוטף עודכן בהצלחה!") {
                console.log('saveTreatment', res);
                // props.showPopUpMessage('טיפול שוטף מסוג תיעוד נוצר בהצלחה');
                props.onClose()
                if (leadIdForTreatment && leadIdForTreatment.length > 0) {
                    dispatch(setReloadLeadTreatments(true));
                }
            }
        } catch (error) {
            console.log('EditReferenceTreatment saveTreatment')
            console.log('error', error)
        }
        // props.onClose();
    }

    const onEmailBodyChange = (html: string) => {
        // Logic to handle email body change
        console.log('Email body changed:', html);
        // Update the treatment object or state as needed
        setSummaryCalling(html);
    }
    return (
        <div className="warpper-popup">
            <div className="header-popup">
                <div className="close-icon pointer" onClick={(e: any) => props.onClose()}></div>
                <div className="title-popup">
                    עריכת סיכום שיחה
                </div>
            </div>
            <div className="body-popup">

                <div className="title">
                    סיכום שיחה
                </div>
                <div className="textarea-wrapper">
                    <DraftEditor
                        initialHtml={summaryCalling}
                        onHtmlChange={(html: string) => onEmailBodyChange(html)}
                    />
                </div>
            </div>
            <div className="footer-popup">
                <button className="button blue pointer" onClick={saveTreatment}>
                    שמור
                </button>

                <button className="button white blue-border pointer" onClick={(e: any) => props.onClose()}>
                    ביטול
                </button>
            </div>
        </div>
    )
}

export default EditCommentCalling